import React from 'react';
import './Modal.css';

/**
 * 通用 Modal 元件
 */
function Modal({ isOpen, title, children, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

/**
 * 加班詢問 Modal
 */
export function OvertimeModal({ isOpen, onConfirm, onCancel }) {
  const [isOvertime, setIsOvertime] = React.useState(null);
  const [hasDinner, setHasDinner] = React.useState(null);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (isOvertime === null) return;
    if (isOvertime === 'yes' && hasDinner === null) return;
    onConfirm({ isOvertime: isOvertime === 'yes', hasDinner });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>⚠️ 下班打卡確認</h3>
        </div>
        <div className="modal-body">
          <p className="warning-text">您今日工時已超過 9.5 小時</p>

          <div className="question-section">
            <p>今日是否為加班？</p>
            <div className="button-group">
              <button
                className={isOvertime === 'yes' ? 'selected' : ''}
                onClick={() => setIsOvertime('yes')}
              >
                是
              </button>
              <button
                className={isOvertime === 'no' ? 'selected' : ''}
                onClick={() => setIsOvertime('no')}
              >
                否 (只是比較晚走)
              </button>
            </div>
          </div>

          {isOvertime === 'yes' && (
            <div className="question-section">
              <p>是否食用晚餐？</p>
              <div className="button-group">
                <button
                  className={hasDinner === true ? 'selected' : ''}
                  onClick={() => setHasDinner(true)}
                >
                  是
                </button>
                <button
                  className={hasDinner === false ? 'selected' : ''}
                  onClick={() => setHasDinner(false)}
                >
                  否
                </button>
              </div>
            </div>
          )}

          <div className="modal-actions">
            <button className="btn-cancel" onClick={onCancel}>取消</button>
            <button
              className="btn-confirm"
              disabled={isOvertime === null || (isOvertime === 'yes' && hasDinner === null)}
              onClick={handleConfirm}
            >
              確認打卡
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * 代打卡原因 Modal
 */
export function ProxyReasonModal({ isOpen, onConfirm, onCancel }) {
  const [reason, setReason] = React.useState('');
  const [customReason, setCustomReason] = React.useState('');

  const REASONS = ['外勤', '手機沒電', '忘記帶磁扣', '其他'];

  const handleConfirm = () => {
    const finalReason = reason === '其他' ? customReason : reason;
    if (!finalReason) return;
    onConfirm(finalReason);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>📝 代打卡原因</h3>
        </div>
        <div className="modal-body">
          <p>請選擇代打卡原因：</p>

          <div className="reason-options">
            {REASONS.map((r) => (
              <button
                key={r}
                className={reason === r ? 'selected' : ''}
                onClick={() => { setReason(r); setCustomReason(''); }}
              >
                {r}
              </button>
            ))}
          </div>

          {reason === '其他' && (
            <input
              type="text"
              placeholder="請輸入原因"
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              className="custom-reason-input"
            />
          )}

          <div className="modal-actions">
            <button className="btn-cancel" onClick={onCancel}>取消</button>
            <button
              className="btn-confirm"
              disabled={!reason || (reason === '其他' && !customReason)}
              onClick={handleConfirm}
            >
              確認代打卡
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;